/* EZMA OUD Reviews Engine — per-product rendering + full Theme Editor settings support */
/* NOTE: PRODUCT_STATS is defined in product-card-ratings.js which loads on every page.
   This file extends it with per-star breakdown data for the reviews section. */
(function () {
  var breakdown = {
    "ezma-al-rawdah-eau-de-parfum-30ml":             {s5:636, s4:13,  s3:8,  s2:2, s1:1},
    "ezma-al-rawdah-eau-de-parfum-100ml":            {s5:592, s4:2,   s3:6,  s2:0, s1:4},
    "ezma-tayba-eau-de-parfum-30ml":                 {s5:518, s4:11,  s3:3,  s2:2, s1:1},
    "ezma-tayba-eau-de-parfum-100-ml":               {s5:606, s4:8,   s3:3,  s2:2, s1:3},
    "bakhoor-alrawdah-harami-ezma-oud":              {s5:465, s4:10,  s3:3,  s2:1, s1:1},
    "bakhoor-kayan-harami-ezma-oud":                 {s5:593, s4:8,   s3:2,  s2:3, s1:2},
    "bakhoor-kayan-ezma-oud":                        {s5:593, s4:8,   s3:2,  s2:3, s1:2},
    "bakhoor-al-rawdah-ezma-oud":                    {s5:563, s4:9,   s3:6,  s2:2, s1:2},
    "bakhoor-tayba-harami-ezma-oud":                 {s5:501, s4:8,   s3:6,  s2:0, s1:1},
    "bakhoor-dylaa-harami-ezma-oud":                 {s5:616, s4:9,   s3:5,  s2:2, s1:1},
    "bakhoor-alrawdah-silver-harami-ezma-oud":       {s5:510, s4:14,  s3:7,  s2:0, s1:7},
    "bakhoor-alrawdah-violet-harami-ezma-oud":       {s5:679, s4:9,   s3:5,  s2:2, s1:5},
    "bakhoor-alrawdah-crimson-harami-ezma-oud":      {s5:663, s4:12,  s3:6,  s2:1, s1:3},
    "bakhoor-al-rawdah-silver-ezma-oud":             {s5:615, s4:11,  s3:6,  s2:4, s1:3},
    "bakhoor-al-rawdah-violet-ezma-oud":             {s5:538, s4:14,  s3:7,  s2:2, s1:4},
    "bakhoor-al-rawdah-crimson-ezma-oud":            {s5:523, s4:8,   s3:9,  s2:1, s1:1},
    "bakhoor-tayba-black-ezma-oud":                  {s5:614, s4:8,   s3:4,  s2:1, s1:6},
    "bakhoor-tayba-blue-ezma-oud":                   {s5:465, s4:10,  s3:6,  s2:2, s1:4},
    "bakhoor-ward-alsultan-ezma-oud":                {s5:679, s4:8,   s3:4,  s2:1, s1:4}
  };
  /* Merge breakdown into PRODUCT_STATS (defined in product-card-ratings.js) */
  if (typeof PRODUCT_STATS !== 'undefined') {
    Object.keys(breakdown).forEach(function (h) {
      if (PRODUCT_STATS[h]) {
        Object.assign(PRODUCT_STATS[h], breakdown[h]);
      } else {
        // If product handle is missing in PRODUCT_STATS, add it from breakdown
        var b = breakdown[h];
        var total = (b.s5||0) + (b.s4||0) + (b.s3||0) + (b.s2||0) + (b.s1||0);
        var avg = total > 0 ? ((b.s5*5 + b.s4*4 + b.s3*3 + b.s2*2 + b.s1*1) / total).toFixed(1) : 5.0;
        PRODUCT_STATS[h] = Object.assign({total: total, avg: parseFloat(avg)}, b);
      }
    });
  }
})();

(function () {
  'use strict';

  /* ── Read theme-editor flags (set by Liquid before this script loads) ── */
  function readFlag(name, fallback) {
    return (typeof window[name] !== 'undefined') ? window[name] : fallback;
  }

  var handle, PROD, PER_PAGE, currentFilter, currentSort, currentPage, filtered, productReviews;
  /* visibility flags — read once on init, re-read on section:load so live preview updates */
  var CFG = {};

  function readConfig() {
    CFG.showAvatar   = readFlag('REVIEWS_SHOW_AVATAR',   true);
    CFG.showDate     = readFlag('REVIEWS_SHOW_DATE',     true);
    CFG.showVerified = readFlag('REVIEWS_SHOW_VERIFIED', true);
    CFG.showTitle    = readFlag('REVIEWS_SHOW_TITLE',    true);
    CFG.showHelpful  = readFlag('REVIEWS_SHOW_HELPFUL',  true);
  }

  function resetState() {
    handle         = (typeof EZMA_PRODUCT_HANDLE !== 'undefined') ? EZMA_PRODUCT_HANDLE : '';
    
    // Ensure PRODUCT_STATS exists
    var statsSource = (typeof PRODUCT_STATS !== 'undefined') ? PRODUCT_STATS : {};
    PROD           = statsSource[handle] || {total:0, avg:5.0, s5:0, s4:0, s3:0, s2:0, s1:0};
    
    // If total is 0 but we have reviews in ALL_REVIEWS, we should calculate stats dynamically
    if (PROD.total === 0 && typeof ALL_REVIEWS !== 'undefined') {
      var reviewsForThisProduct = ALL_REVIEWS.filter(function(r) { return r.h === handle; });
      if (reviewsForThisProduct.length > 0) {
        var total = reviewsForThisProduct.length;
        var sum = 0;
        var s5=0, s4=0, s3=0, s2=0, s1=0;
        reviewsForThisProduct.forEach(function(r) {
          sum += r.r;
          if (r.r === 5) s5++;
          else if (r.r === 4) s4++;
          else if (r.r === 3) s3++;
          else if (r.r === 2) s2++;
          else if (r.r === 1) s1++;
        });
        PROD = {
          total: total,
          avg: parseFloat((sum / total).toFixed(1)),
          s5: s5, s4: s4, s3: s3, s2: s2, s1: s1
        };
      }
    }

    PER_PAGE       = readFlag('REVIEWS_PER_PAGE', 12);
    currentFilter  = 'all';
    currentSort    = 'recent';
    currentPage    = 0;
    filtered       = [];
    productReviews = [];
    readConfig();
  }

  /* ── Helpers ── */
  function el(id) { return document.getElementById(id); }

  function stars(n) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out += '<span class="' + (i <= n ? 'star-filled' : 'star-empty') + '">★</span>';
    }
    return out;
  }

  function avatarColor(name) {
    var colors = [
      'linear-gradient(135deg,#C9A84C,#E4C86A)',
      'linear-gradient(135deg,#0F5C3E,#1A7A52)',
      'linear-gradient(135deg,#8B6914,#C9A84C)',
      'linear-gradient(135deg,#062B1A,#0F5C3E)',
      'linear-gradient(135deg,#1A7A52,#2EAD73)'
    ];
    return colors[name.charCodeAt(0) % colors.length];
  }

  function initials(name) {
    return name.split(' ').slice(0, 2).map(function (w) { return w[0]; }).join('');
  }

  function fmtDate(d) {
    return new Date(d).toLocaleDateString('en-MY', {year:'numeric', month:'short', day:'numeric'});
  }

  /* ── Build a single review card respecting all visibility flags ── */
  function buildCard(rv) {
    var html = '<div class="review-card" data-rating="' + rv.r + '">';

    /* — Header row — */
    html += '<div class="review-card__header">';
    html += '<div class="review-card__author">';

    /* Avatar */
    if (CFG.showAvatar) {
      html += '<div class="review-card__avatar" style="background:' + avatarColor(rv.n) + '">' + initials(rv.n) + '</div>';
    }

    /* Name + verified */
    html += '<div>';
    html += '<p class="review-card__name">' + rv.n + '</p>';
    if (CFG.showVerified) {
      html += '<span class="review-card__verified">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="20,6 9,17 4,12"/></svg>'
        + 'Verified Purchase</span>';
    }
    html += '</div>';
    html += '</div>'; /* end .review-card__author */

    /* Date */
    if (CFG.showDate) {
      html += '<span class="review-card__date">' + fmtDate(rv.d) + '</span>';
    }

    html += '</div>'; /* end .review-card__header */

    /* Stars */
    html += '<div class="review-card__stars">' + stars(rv.r) + '</div>';

    /* Title */
    if (CFG.showTitle) {
      html += '<p class="review-card__title">' + rv.t + '</p>';
    }

    /* Body text */
    html += '<p class="review-card__text">' + rv.b + '</p>';

    /* Footer — helpful button */
    if (CFG.showHelpful) {
      html += '<div class="review-card__footer">'
        + '<button class="review-helpful" aria-label="Mark as helpful">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">'
        + '<path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z"/>'
        + '<path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"/></svg>Helpful</button>'
        + '</div>';
    }

    html += '</div>'; /* end .review-card */
    return html;
  }

  /* ── Sorting ── */
  function applySort(arr) {
    return arr.slice().sort(function (a, b) {
      if (currentSort === 'recent')  return new Date(b.d) - new Date(a.d);
      if (currentSort === 'highest') return b.r - a.r;
      if (currentSort === 'lowest')  return a.r - b.r;
      return 0;
    });
  }

  /* ── Render the current page of results ── */
  function render() {
    var grid = document.getElementById('reviewsGrid');
    if (!grid) return;

    var show  = filtered.slice(0, (currentPage + 1) * PER_PAGE);
    grid.innerHTML = show.map(buildCard).join('');

    var shown = show.length;
    var total = filtered.length;
    var pt    = el('progressText');
    var pf    = el('progressFill');
    var vc    = el('visibleCount');

    if (pt) pt.textContent = 'Showing ' + shown + ' of ' + total + ' reviews';
    if (pf) pf.style.width = (total ? Math.round(shown / total * 100) : 0) + '%';
    if (vc) vc.textContent = '(' + total + ')';

    var btn = el('loadMoreBtn');
    if (btn) {
      if (shown >= total) {
        btn.disabled    = true;
        btn.textContent = 'All Reviews Loaded';
      } else {
        btn.disabled = false;
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12l7 7 7-7"/></svg> Load More Reviews';
      }
    }
  }

  /* ── Apply active filter + re-sort ── */
  function refresh() {
    currentPage = 0;
    filtered = applySort(
      currentFilter === 'all'
        ? productReviews
        : productReviews.filter(function (r) { return r.r === parseInt(currentFilter, 10); })
    );
    render();
  }

  /* ── Wire up interactive controls ── */
  function bindEvents() {
    /* Star filter tabs */
    document.querySelectorAll('.reviews-filter-btn').forEach(function (btn) {
      btn.onclick = function () {
        document.querySelectorAll('.reviews-filter-btn').forEach(function (b) {
          b.classList.remove('active');
          b.setAttribute('aria-selected', 'false');
        });
        this.classList.add('active');
        this.setAttribute('aria-selected', 'true');
        currentFilter = this.dataset.filter;
        refresh();
      };
    });

    /* Breakdown bar rows */
    document.querySelectorAll('.breakdown-row').forEach(function (row) {
      row.onclick = function () {
        var f = this.dataset.filter;
        document.querySelectorAll('.reviews-filter-btn').forEach(function (b) {
          b.classList.toggle('active', b.dataset.filter === f);
          b.setAttribute('aria-selected', b.dataset.filter === f ? 'true' : 'false');
        });
        currentFilter = f;
        refresh();
      };
    });

    /* Sort dropdown */
    var sortEl = el('reviewsSort');
    if (sortEl) sortEl.onchange = function () { currentSort = this.value; refresh(); };

    /* Load more */
    var moreBtn = el('loadMoreBtn');
    if (moreBtn) moreBtn.onclick = function () { currentPage++; render(); };
  }

  /* ── Main init ── */
  function init() {
    if (typeof ALL_REVIEWS === 'undefined') { setTimeout(init, 50); return; }

    resetState();
    productReviews = ALL_REVIEWS.filter(function (rv) { return rv.h === handle; });

    /* Calculate precise average and percentages if total > 0 */
    if (PROD.total > 0) {
      var sum = ((PROD.s5||0) * 5) + ((PROD.s4||0) * 4) + ((PROD.s3||0) * 3) + ((PROD.s2||0) * 2) + ((PROD.s1||0) * 1);
      var rawAvg = sum / PROD.total;
      // Use floor (truncation) to 1 decimal so e.g. 4.9523 → 4.9, never rounds up to 5.0
      PROD.avg = (Math.floor(rawAvg * 10) / 10).toFixed(1);
    }

    /* Populate summary stats */
    if (el('avgRating'))  el('avgRating').textContent  = PROD.avg;
    if (el('totalCount')) el('totalCount').textContent = PROD.total;
    if (el('topTotalCount')) el('topTotalCount').textContent = PROD.total;
    
    if (el('avgStars') && typeof buildStars === 'function') {
      el('avgStars').innerHTML = buildStars(parseFloat(PROD.avg));
    }

    var barsData = [
      {id:'bar5', pctId:'pct5', n: PROD.s5 || 0},
      {id:'bar4', pctId:'pct4', n: PROD.s4 || 0},
      {id:'bar3', pctId:'pct3', n: PROD.s3 || 0},
      {id:'bar2', pctId:'pct2', n: PROD.s2 || 0},
      {id:'bar1', pctId:'pct1', n: PROD.s1 || 0}
    ];

    // Step 1: raw percentages
    var pcts = barsData.map(function(b) {
      return PROD.total ? (b.n / PROD.total * 100) : 0;
    });

    // Step 2: ALL bars use 1-decimal format — mixing integers with decimals causes sums like 99.3%
    var formatted = pcts.map(function(rawPct) {
      if (rawPct === 0) return { num: 0,                             str: '0%' };
      return                   { num: parseFloat(rawPct.toFixed(1)), str: rawPct.toFixed(1) + '%' };
    });

    // Step 3: absorb any remaining rounding gap (±0.1) into the dominant bar → always sums to 100%
    var displaySum = parseFloat(formatted.reduce(function(acc, f) { return acc + f.num; }, 0).toFixed(1));
    var gap        = parseFloat((100 - displaySum).toFixed(1));
    if (gap !== 0 && PROD.total > 0) {
      var dominantIdx = 0;
      barsData.forEach(function(b, i) { if (b.n > barsData[dominantIdx].n) dominantIdx = i; });
      var adj = parseFloat((formatted[dominantIdx].num + gap).toFixed(1));
      formatted[dominantIdx].num = adj;
      formatted[dominantIdx].str = adj.toFixed(1) + '%';
    }

    barsData.forEach(function(b, i) {
      var rawPct = pcts[i];
      var barEl  = el(b.id);
      var pctEl  = el(b.pctId);
      if (barEl) {
        var visualWidth = (b.n > 0 && rawPct < 0.5) ? 0.5 : rawPct;
        barEl.style.width = visualWidth + '%';
        barEl.dataset.width = rawPct;
        if (barEl.parentElement) barEl.parentElement.style.overflow = 'hidden';
      }
      if (pctEl) pctEl.textContent = formatted[i].str;
    });

    /* Filter count badges */
    var fcMap = { all: PROD.total, 5: PROD.s5, 4: PROD.s4, 3: PROD.s3, 2: PROD.s2, 1: PROD.s1 };
    Object.keys(fcMap).forEach(function (k) {
      var fc = el('fc-' + k);
      if (fc) fc.textContent = fcMap[k];
    });

    bindEvents();
    refresh();
    // Dispatch event for other components (like top rating) to update
    document.dispatchEvent(new CustomEvent('reviews:loaded'));
  }

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── Shopify Theme Editor live-reload support ── */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.reviews-section')) {
      /* Re-read flags because Liquid re-rendered with new settings */
      readConfig();
      PER_PAGE = readFlag('REVIEWS_PER_PAGE', 12);
      init();
    }
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.reviews-section')) {
      readConfig();
      PER_PAGE = readFlag('REVIEWS_PER_PAGE', 12);
      init();
    }
  });

})();

/* Product card ratings are handled by product-card-ratings.js (loaded globally in theme.liquid) */
